import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { FireTrackAnalytics } from '@atlassian/analytics-bridge/fire-analytics';
import { Action, ActionSubject } from '@atlassian/proforma-utilities/analytics/events';

import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';

export const UnknownField = ({ fieldId }: FormFieldComponentRendererProps): React.JSX.Element => (
	<Box testId="unknown-field">
		<FireTrackAnalytics
			actionSubject={ActionSubject.FORM_FIELD}
			action={Action.FAILED}
			actionSubjectId="proformaFormRenderer"
			attributes={{ fieldId, isUnknownField: true }}
		/>
	</Box>
);
